// Import model
import { FilterSubmissionRequest } from '../models/FilterSubmissionRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { SubmissionCondition } from '../models/SubmissionCondition';
import { SubmissionFields } from '../models/SubmissionFields';
import { SubmissionIndexedFields } from '../models/SubmissionIndexedFields';

// Import dependency serializers (for complex types)
import { SubmissionConditionSerializer } from './SubmissionConditionSerializer';
import { SubmissionFieldsSerializer } from './SubmissionFieldsSerializer';
import { SubmissionIndexedFieldsSerializer } from './SubmissionIndexedFieldsSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for FilterSubmissionRequest - handles JSON serialization and deserialization with type validation
 */
export class FilterSubmissionRequestSerializer {
  /**
   * Deserializes a JSON string into a FilterSubmissionRequest instance
   */
  static deserialize(json: string): FilterSubmissionRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a FilterSubmissionRequest instance
   */
  static fromObject(obj: any): FilterSubmissionRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to FilterSubmissionRequest');
    }


    const instance: FilterSubmissionRequest = {
      top: obj['top'] as number | undefined,
      skip: obj['skip'] as number | undefined,
      orderBy: obj['orderBy'] as SubmissionIndexedFields | undefined,
      reverseOrder: obj['reverseOrder'] as boolean | undefined,
      view: obj['view'] as string | undefined,
      fields: obj['fields'] ? (obj['fields'] as any[]).map((item: any) =>
        item as SubmissionFields
      ) : [] as any,
      criteria: obj['criteria'] ? (obj['criteria'] as any[]).map((item: any) =>
        SubmissionConditionSerializer.fromObject(item)
      ) : [] as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of FilterSubmissionRequest instances
   */
  static deserializeArray(json: string): FilterSubmissionRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a FilterSubmissionRequest instance to a JSON string
   */
  static serialize(instance: FilterSubmissionRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a FilterSubmissionRequest instance to a plain object
   */
  static toObject(instance: FilterSubmissionRequest): any {
    return {
      'top': instance.top,
      'skip': instance.skip,
      'orderBy': instance.orderBy,
      'reverseOrder': instance.reverseOrder,
      'view': instance.view,
      'fields': instance.fields?.map((item: any) =>
        item
      ),
      'criteria': instance.criteria?.map((item: any) =>
        SubmissionConditionSerializer.toObject(item)
      ),
    };
  }

  /**
   * Serializes an array of FilterSubmissionRequest instances to a JSON string
   */
  static serializeArray(instances: FilterSubmissionRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
